import Pill from './pill.js';
export default Pill;
